import { styled } from '~ui-kit/styled-components';

export const DialogTitle = styled.h2`
  font-size: 1.25rem;
  line-height: 1.5rem;
  font-family: ${(props) => props.theme.fontFamily.poppins};
  font-weight: 600;
  margin: 0;
`;
